import { render, staticRenderFns } from "./StellantisConsentComponent.vue?vue&type=template&id=f376aa46"
import script from "./StellantisConsentComponent.vue?vue&type=script&lang=ts"
export * from "./StellantisConsentComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports